module.exports = __webpack_public_path__ + "img/image-03-sp.8b830248.jpg";